import { render, staticRenderFns } from "./TiPanel.vue?vue&type=template&id=701d7211&scoped=true"
import script from "./TiPanel.vue?vue&type=script&lang=js"
export * from "./TiPanel.vue?vue&type=script&lang=js"
import style0 from "./TiPanel.vue?vue&type=style&index=0&id=701d7211&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d7211",
  null
  
)

export default component.exports